export const SKELETON_BODY_COUNT = 12;
